import { render, staticRenderFns } from "./patenttransManage.vue?vue&type=template&id=786d174f&scoped=true"
import script from "./patenttransManage.vue?vue&type=script&lang=js"
export * from "./patenttransManage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "786d174f",
  null
  
)

export default component.exports